import React from 'react';
import { useState, useEffect } from "react";
import img1 from "../../assets/images/contact/get-in-touch.webp";
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import FormService from '../API-Services/FormService';
import LazyLoader from '../Common-features/LazyLoader';
import { MultiSelect } from 'react-multi-select-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import PhoneInput, {
  isValidPhoneNumber,
  getCountryCallingCode,
} from "react-phone-number-input";
const products = [
  { label: "Prime: Procurement", value: "1" },
  { label: "Prime: Cash Flow Management", value: "2" },
  { label: "Prime: Employee Benefits", value: "3" },
  { label: "Choice Touch", value: "4" },
  { label: "Greetly", value: "5" },
  { label: "Drive Assure", value: "6" },
  { label: "Trans-Track", value: "7" },
  // { label: "Telelyzer", value: "8" },
];

const services = [
  { label: "Android Development", value: "1" },
  { label: "iOS Development", value: "2" },
  { label: "Web Development", value: "3" },
  { label: "Tech Consultation", value: "4" },
  { label: "Data Loss Prevention (DLP)", value: "5" },
  { label: "Data Classification Platform", value: "6" },
  { label: "Red Teaming", value: "7" },
];

function ContactForm() {
  const [showError, setShowError] = useState(false);
  const [numberLen, setNumberLen] = useState(25);
  const [countryCode, setCountryCode] = useState("91");
  const [mobileNum, setmobileNum] = useState("");
  const [num_error, setNum_error] = useState("");
  const [selected, setSelected] = useState([]);
  const [selected2, setSelected2] = useState([]);
  const [showToaster, setShowToaster] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({mode:"onChange"});

  const [loading,setLoading]=useState(false);

  const [checkErrors,setCheckErrors]=useState(false);

  function scrollErrorField(){
   //scroll up if there is any error
   if (Object.keys(errors).length > 0 && checkErrors) {
    const firstErrorField = Object.keys(errors)[0];
    // Get the corresponding input element
    const errorFieldElement = document.querySelector(
      `[name=${firstErrorField}]`
    );
    // Scroll to the error field if it exists
    if (errorFieldElement) {
      errorFieldElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    }
  }
  }
 
 //Mobile Validation
 const mobileHandler = (e) => {
  if (e === undefined) {
    return;
  }
  const newValue = e.replace(/\s/g, ''); // Remove spaces from the entered value
  setmobileNum(newValue);
  // Perform other validation checks on the modified value
  if (newValue === undefined || newValue.length === 0) {
    setNum_error("Mobile Number is required");
    setShowError(true);
    return;
  }

  if (countryCode === "91") {
    setNumberLen(15);
  }
  else {
    setNumberLen(25);
  }

  if (!isValidPhoneNumber(newValue.toString())) {
    setNum_error("Please enter a valid number");
    setShowError(true);
    return;
  }
  else {
    setNum_error("");
    setShowError(false);
  }
}

  useEffect(() => {
    if (showToaster) {
      const timer = setTimeout(() => {
        setShowToaster(false);
      }, 10000); // Hide toaster after 10 seconds

      return () => clearTimeout(timer); 
    }
  }, [showToaster]);
  
 // Form Handler
  const contactFormHandler=(data)=>{
    const productsSelected = selected.map(item => item.label);
    const servicesSelected = selected2.map(item => item.label);
    let interestedIn = "";
    if (productsSelected.length > 0 && servicesSelected.length > 0) {
      interestedIn = "products/services";
    } else if (productsSelected.length > 0) {
      interestedIn = "products";
    } else if (servicesSelected.length > 0) {
      interestedIn = "services";
    }
    

    let payload={
      ...data,
      contact_number:mobileNum.substring(mobileNum.indexOf(countryCode)+countryCode.length),
      country_code:countryCode,
      product : productsSelected.join(", "),
      services : servicesSelected.join(", "),
      interested_in:interestedIn,
      enquiry_type:"contact_us"
      }

  setLoading(true);
  FormService.ContactForm(payload).then((res)=>{
  setLoading(false);
  reset();
  setmobileNum("");
  setSelected([]);
      setSelected2([]);
  // toast.success(res.data.message);
  setShowToaster(true)
  }).catch((err)=>{
    setLoading(false);
    if (err && err.response && err.response.data && err.response.data.message) {
      toast.error(err.response.data.message);
      }
      else{
        toast.error("Something went wrong, please try again later!");
      }
  })
  }
  

  return (
    <>
        <section className='contact-form'>
            <div className='container'>
                <div className='form-wrap'>
                    <div className='lft-form'>
                        <LazyLoader src={img1} className='' alt={"Get in Touch"} width={558} height={617} />
                    </div>
                    <div className='rght-form'>
                        <div className='clt-form'>
                            <div className='frm-head'>
                              <h3 className='ttl1'>Get in Touch</h3>
                              <p className='sm-para'>Have a question or a project in mind? Fill out the form below, and our team will get back to you promptly.</p>
                            </div>
                            <form onSubmit={handleSubmit(contactFormHandler)}>
                            <div className='form-wrapper'>
                              <div className="form-control">
                                <input
                                  type="text"
                                  name="name"
                                  placeholder='Full Name' className='form-field'
                                  maxLength={120}
                                  autoComplete='off'
                                  {...register("name",{
                                  required:true,
                                  pattern: /^[a-zA-z]+([\s][a-zA-Z]+)*$/
                                  })}
                                  onInput={(e)=>e.target.value=e.target.value.replace(/[^a-zA-Z ]/gi,"")}
                                />
                                {errors.name?.type==="required" ? <span className="text-danger">Name is required </span>:
                                 errors.name?.type==="pattern" ? <span className="text-danger">Please provide valid name</span>:""}
                              </div>
                              <div className="form-control">
                                <input
                                  type="text"
                                  name="email"
                                  placeholder='Email Address' className='form-field'
                                  autoComplete='off'
                                  {...register("email",
                                  {
                                  required:true,
                                  pattern:/^[a-zA-Z]{1}[A-Za-z0-9._%+-]{1,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})$/
                                  }
                                  )}
                                />
                                {errors.email?.type==="pattern" ? <span className="text-danger">Please enter valid email ID </span>:
                                 errors.email?.type==="required" ? <span className="text-danger">Email is required</span>:""}
                              </div>
                              <div className="form-control" onValuesChange={(val, all) => console.log(val, all)}>
                                  <div name="phone" label="aa">
                                    <PhoneInput
                                      placeholder="Enter phone number"
                                      value={mobileNum}
                                      name="phone_number"
                                      autoComplete="off"
                                      onChange={(e) => {
                                        mobileHandler(e);
                                      }}
                                      onCountryChange={(v) =>
                                        setCountryCode(getCountryCallingCode(v))
                                      }
                                      maxLength={numberLen}
                                      defaultCountry="IN"
                                      international
                                      countryCallingCodeEditable={false}
                                    />
                                  </div>
                                {showError && (
                                  <span className="text-danger">{num_error}</span>
                                )}
                              </div>
                              
                              <div className="form-control">
                                <input
                                  type="text"
                                  name="company_name"
                                  placeholder='Company Name' className='form-field'
                                  maxLength={120}
                                  autoComplete='off'
                                  {...register("company_name",{
                                    required:true,
                                    pattern: /^[a-zA-z]+([\s][a-zA-Z]+)*$/
                                    })}

                                    onInput={(e)=>e.target.value=e.target.value.replace(/[^a-zA-Z ]/gi,"")}
                                />
                                 {errors.company_name?.type==="required" ? <span className="text-danger">Company Name is required </span>:
                                 errors.company_name?.type==="pattern" ? <span className="text-danger">Please provide valid Company Name</span>:""}
                              </div>
                              <div className='form-control form-select'>
                              <div className='drowpdown-select'>
                                  <label>Interested In</label>
                                  <div className='form-control'>
                                    <MultiSelect className='select-checkbox' options={products} value={selected} onChange={setSelected}
                                    labelledBy="Products" disableSearch overrideStrings={{ selectSomeItems: "Products" }}/>
                                  </div>
                                  <div className='form-control'>
                                    <MultiSelect className='select-checkbox' options={services}  value={selected2} onChange={setSelected2}
                                    labelledBy="Services" disableSearch overrideStrings={{ selectSomeItems: "Services" }} />
                                  </div>
                               </div>
                              </div>
                              
                             
                              <div className="form-control">
                                <textarea className="form-field" placeholder="Comments" name="comments" 
                                autoComplete='off'
                                {...register("comments")}/>
                              </div>
                              <div className="form-control">
                                  <button type='submit' className='btn submt-btn' onClick={() => {
                        setCheckErrors(true);
                        scrollErrorField();
                        if (mobileNum.length <= 3) {
                          setNum_error("Mobile Number is required");
                          setShowError(true);
                        }
                      }} disabled={loading}>{loading ? <div className='loaderB mx-auto'></div>: "Submit"}</button>
                              </div>
                              </div>
                           </form>
                        </div>
                    </div>
                    
                    <div className={`toaster toaster-top ${showToaster ? 'toaster-active' : ''}`}>
                      <div className='close-tst' onClick={() => setShowToaster(false)}>
                        <FontAwesomeIcon icon={faClose} />
                      </div>
                      <h3 className='tst-heading'>Thank You for dropping us a Hint!</h3>
                    </div>
                </div>
            </div>
        </section>
    </>

  )
}

export default ContactForm;
